import type { NotificationSettingsResponse } from '../api/client';

/**
 * リマインドが「実際には届かない状態」かを判定する。
 *
 * 背景（課題 #78）: 稼働中のテナントで 81 人中 1 人しかリマインドが設定されていなかった。
 * 原因は通知設定画面の見え方にある。BE が reminder_time: null（＝時刻未設定）を返しても、
 * 画面はチェックボックスが ON・時刻欄が 09:00 の状態で描画されるため、利用者からは
 * 「設定済み」に見える。そのまま保存せず離脱するとリマインドは永久に届かない。
 *
 * checkin_enabled が false のときは利用者が意図的に切っているため対象外とする。
 * 催促してよいのは「受け取るつもりなのに時刻が無い」という食い違いのときだけ。
 */
export function isReminderUnset(
  settings: NotificationSettingsResponse | null | undefined
): boolean {
  if (!settings) return false; // 取得できていない間は催促しない
  if (!settings.checkin_enabled) return false; // 本人が OFF にしている
  const time = settings.reminder_time;
  return time == null || time.trim() === '';
}
